/* eslint-disable react/jsx-key */
import { cn } from '@/lib/utils'
import * as React from 'react'

// Spinner from here: https://loading.io/css/
export const LoadingSpinner = ({
  className,
  light,
  color
}: {
  className?: string
  light?: boolean
  color?: string
}): React.ReactElement => {
  return (
    <div className={cn('relative', className)}>
      {new Array(4).fill(0).map((_, index) => (
        <span
          className={cn('spinner-div border-2', {
            'border-[rgb(var(--on-surface-inverted))_transparent_transparent_transparent]': light,
            'border-[rgb(var(--on-surface))_transparent_transparent_transparent]': !light
          })}
          key={index}
          style={color ? { borderColor: `${color} transparent transparent transparent` } : undefined}
        />
      ))}
    </div>
  )
}
